module.exports = __webpack_public_path__ + "static/media/dashboardBorrower.78af3a39.svg";